module.exports = __webpack_public_path__ + "static/media/image_4.7ae201ec.png";